import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import {
  ACCOUNTS_VALUE_CHANGES_REDUCER_KEY,
  type AccountsValueChangesColumnCollection,
  type AccountsValueChangesRowList,
  type AccountsValueChangesStore,
} from './accountsValueChangesTypes';

export type AccountsValueChangesSelectorsState = Pick<RootState, typeof ACCOUNTS_VALUE_CHANGES_REDUCER_KEY>;

export const getStore = (state: AccountsValueChangesSelectorsState): AccountsValueChangesStore =>
  state[ACCOUNTS_VALUE_CHANGES_REDUCER_KEY];

export const getLoadPending = (state: AccountsValueChangesSelectorsState): boolean | undefined =>
  getStore(state).loadPending;
export const getIsLoading = (state: AccountsValueChangesSelectorsState): boolean | undefined =>
  getStore(state).isLoading;
export const getError = (state: AccountsValueChangesSelectorsState): unknown => getStore(state).error;
export const getRows = (state: AccountsValueChangesSelectorsState): AccountsValueChangesRowList | undefined =>
  getStore(state).rows;
export const getColumns = (
  state: AccountsValueChangesSelectorsState,
): AccountsValueChangesColumnCollection | undefined => getStore(state).columns;

const getColumnByIndex = (columns: AccountsValueChangesColumnCollection | undefined, index: number) =>
  Array.isArray(columns) ? columns[index] : undefined;

export const addHeaderNametoCellData = createSelector([getRows, getColumns], (valueRows, valueColumns) => {
  valueRows?.forEach((row) => {
    row?.cellData?.forEach((cell, index) => {
      const columnValue = getColumnByIndex(valueColumns, index);
      if (columnValue?.headerName) cell.headerName = columnValue.headerName;
    });
  });
  return valueRows;
});

export const getDailyValueChanges: typeof addHeaderNametoCellData = addHeaderNametoCellData;

export const getTotalBalanceCell = createSelector(
  [getRows],
  (rows): number | null | undefined => rows?.find((item) => item.name === 'Total')?.cellData?.[0]?.value,
);
